import React, { useCallback } from "react";
import Button from "@mui/material/Button";
import {
  Alert,
  AlertTitle,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Divider,
  IconButton,
  Snackbar,
  Stack,
  Tooltip,
  Box,
  Typography,
  Select,
  MenuItem,
  AppBar,
  FormControl,
  styled,
  InputBase,
  TextField,
  useTheme,
} from "@mui/material";
import { Link } from "react-router-dom";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon";
import { useState } from "react";
import { useEffect } from "react";
import NetworkWifi3BarIcon from "@mui/icons-material/NetworkWifi3Bar";
import CloseIcon from "@mui/icons-material/Close";

const ListPageHeader = ({
  btnDisable,
  handleBack,
  handleSubmit,
  handlePurge,
  onBtExport,
  pageName,
  pagination,
  addPageLink,
  deleteDisable,
  addEnable,
  ViewIcon,
  editDisable,
  componentName,
  gridRef,
  error,
  searchIcon,
  pageSize,
  handleAddButton,
  handleAddButtonEnable,
  handleEditButton,
  headerInputFields,
  snackState,
  successMsg,
  showPaginationDropdown,
  onBtPrint,
  breadCrumbs,
  handleShowRoomQuestionNext,
  handleRequestReviewNext,
  headerFieldsBottom,
  handleSubmitForReview,
  handleApprove,
  handleRequestChange,
  handleApproveAll,
  status,
  requestCategory,
  onResetColumnState,
  orderHeaderAction,
  placeOrder,
  orderFilter,
  handleConfig,
  tabcontent,
  setSnackState,
  onExpandClick,
  isExpand,
  onAddHeadClick,
}) => {
  const [open, setOpen] = useState(false);
  const [openSnack, setOpenSnack] = useState(snackState || false);
  const [selectedSize, setSelectedSize] = useState(pageSize || 10);
  const [paginationDropdown, setPaginationDropdown] = useState(true);
const theme = useTheme();
  const handleClose = () => {
    setOpen(false);
  };

  const handleSnackClose = () => {
    setOpenSnack(false);
    if (setSnackState) {
      setSnackState(false);
    }
  };

  useEffect(() => {
    if (!setSnackState) {
      setOpenSnack(snackState);
    }
  }, [snackState]);

  const deleteData = () => {
    setOpen(false);
    handlePurge();
  };
  useEffect(() => {
    if (error === "Network Error") {
      setOpen(true);
    }
  }, [error]);

  const onPageSizeChanged = useCallback((e) => {
    setSelectedSize(e.target.value);
    var value = e.target.value;
    gridRef?.current?.api?.paginationSetPageSize(value);
  }, [gridRef]);

  const handleDefaultGridState = () => {
    gridRef.current.api.setFilterModel(null);
    if (componentName === 'Sales Budget') {
      gridRef.current.columnApi.resetColumnState();
      gridRef?.current?.columnApi?.autoSizeAllColumns();
      const allColumnIds = []
      gridRef.current.columnApi.getColumns().forEach((column) => {
        if (column.rowGroupActive === false) {
          allColumnIds.push(column.getId());
        }
      })
      gridRef.current.columnApi.autoSizeColumns(allColumnIds, false);
    } else {
      gridRef.current.columnApi.resetColumnState();
    }
    onResetColumnState && onResetColumnState();
  };

  return (
    <>
      <AppBar color="inherit" className="sticky z-20" sx={{ borderRadius: 0 }}>
        <div className="flex flex-col sm:flex-row gap-12 sm:gap-16 flex-1 w-full items-start sm:items-center justify-between py-10 px-12 sm:px-24">
          <div className="text-20 sm:text-24 md:text-32 font-extrabold tracking-tight min-w-0 w-full sm:w-auto">
            <h1 className="break-words">
              {pageName && pageName?.toUpperCase()}{" "}
              {requestCategory && (
                <Box
                  component="span"
                  sx={{
                    fontSize: 16,
                    background: "#458DC1",
                    borderRadius: 16,
                    ml: 1,
                    py: 1,
                    px: 3,
                  }}
                >
                  {requestCategory}
                </Box>
              )}
            </h1>
            {breadCrumbs && breadCrumbs}
          </div>
          <div
            className={
              headerFieldsBottom +
              `{ flex flex-col w-full sm:w-auto sm:flex-row space-y-16 sm:space-y-0 flex-1 items-center justify-end space-x-8 ${tabcontent} }`
            }
          >
            <Stack
              direction="row"
              alignItems="center"
              sx={{
                width: "100%",
                gap: 1,
                flexWrap: "wrap",
                justifyContent: { xs: "flex-start", sm: "flex-end" },
                // the buttons carry their own mb: 1; with wrapping + gap that misaligns rows
                "& .MuiButton-root": { mb: 0 },
              }}
            >
              {handleBack && (
                <Button
                  onClick={handleBack}
                  variant="outlined"
                  startIcon={
                    <FuseSvgIcon>material-outline:navigate_before</FuseSvgIcon>
                  }
                >
                  Back
                </Button>
              )}
              {/* {
                                handleBack && <Link to={handleBack}><FuseSvgIcon>material-outline:navigate_before</FuseSvgIcon> Back</Link>
                            } */}
              {handleSubmit && (
                <Button
                  type="submit"
                  onClick={handleSubmit}
                  variant="contained"
                  color="secondary"
                  className="mx-auto"
                  startIcon={
                    <FuseSvgIcon>heroicons-solid:document</FuseSvgIcon>
                  }
                >
                  Save
                </Button>
              )}

              {headerInputFields && headerInputFields}
              {orderHeaderAction && orderHeaderAction}
              {orderFilter && orderFilter}
              {placeOrder && placeOrder}
              {addPageLink && (
                <Tooltip title={"Add " + componentName}>
                  <Link to={addPageLink}>
                    <Button variant="contained" color="secondary">
                      <FuseSvgIcon>heroicons-solid:plus-circle</FuseSvgIcon>
                    </Button>
                  </Link>
                </Tooltip>
              )}

              {searchIcon && (
                <Tooltip title={"Search " + componentName}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={searchIcon}
                  >
                    <FuseSvgIcon>heroicons-solid:search</FuseSvgIcon>
                  </Button>
                </Tooltip>
              )}

              {handleAddButton && (
                <Tooltip title={"Add " + componentName}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleAddButton}
                  >
                    <FuseSvgIcon>heroicons-solid:plus-circle</FuseSvgIcon>
                  </Button>
                </Tooltip>
              )}
              {handleAddButtonEnable && (
                <Tooltip title={"Add " + componentName}>
                  <span>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={handleAddButtonEnable}
                      disabled={addEnable}
                    >
                      Create Order
                    </Button>
                  </span>
                </Tooltip>
              )}
              {handleEditButton && (
                <Tooltip title={"Edit " + componentName}>
                  <Button
                    variant="contained"
                    color="secondary"
                    disabled={editDisable || false}
                    onClick={handleEditButton}
                  >
                    <FuseSvgIcon>heroicons-solid:pencil</FuseSvgIcon>
                  </Button>
                </Tooltip>
              )}

              {ViewIcon && (
                <Tooltip title={"View " + componentName}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={ViewIcon}
                  >
                    <FuseSvgIcon>heroicons-solid:eye</FuseSvgIcon>
                  </Button>
                </Tooltip>
              )}

              {handlePurge && (
                <Tooltip title={"Delete " + componentName}>
                  <Button
                    variant="contained"
                    color="error"
                    disabled={deleteDisable || false}
                    onClick={(e) => setOpen(true)}
                  >
                    <FuseSvgIcon>heroicons-solid:trash</FuseSvgIcon>
                  </Button>
                </Tooltip>
              )}
              {handlePurge && (
                <Dialog
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      Are you sure you want to delete?
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={deleteData}>Yes</Button>
                    <Button onClick={handleClose} autoFocus>
                      No
                    </Button>
                  </DialogActions>
                </Dialog>
              )}
              {handleConfig && (
                <Tooltip title={"Add Configuration"}>
                  <Button
                    onClick={handleConfig}
                    variant="contained"
                    color="secondary"
                    className="mx-auto"
                    startIcon={
                      <FuseSvgIcon className="mx-auto">
                        heroicons-solid:cog
                      </FuseSvgIcon>
                    }
                  />
                </Tooltip>
              )}
              {onExpandClick && (
                <Button
                  variant="contained"
                  color="secondary"
                  type="button"
                  onClick={onExpandClick}
                  className="mr-8"
                >
                  {isExpand ? "Expand All" : "Collapse All"}
                </Button>
              )}
              {onAddHeadClick && (
                <Button
                  color="secondary"
                  variant="contained"
                  startIcon={
                    <FuseSvgIcon size={18}>heroicons-outline:plus</FuseSvgIcon>
                  }
                  onClick={onAddHeadClick}
                >
                  Add Head
                </Button>
              )}
              {onBtExport && (
                <Tooltip title={"Export " + componentName}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={onBtExport}
                    sx={{
                      mb: 1,
                      fontWeight: "bold",
                    }}
                  >
                    <FuseSvgIcon>heroicons-solid:save</FuseSvgIcon>
                  </Button>
                </Tooltip>
              )}
              {onBtPrint && (
                <Tooltip title={"Print " + componentName}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={onBtPrint}
                    sx={{
                      mb: 1,
                      fontWeight: "bold",
                    }}
                  >
                    <FuseSvgIcon>heroicons-outline:printer</FuseSvgIcon>
                  </Button>
                </Tooltip>
              )}
              {/* {handleBack && <Button
                                variant="outlined"
                                color="secondary"
                                onClick={handleBack}
                                style={{ marginBottom: '5px', fontWeight: 'bold' }}
                            >
                                Back
                            </Button>} */}
              {handleShowRoomQuestionNext && (
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={handleShowRoomQuestionNext}
                  sx={{
                    mb: 1,
                    fontWeight: "bold",
                  }}
                  endIcon={
                    <FuseSvgIcon>material-outline:navigate_next</FuseSvgIcon>
                  }
                >
                  Next
                </Button>
              )}
              {handleRequestReviewNext && (
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={handleRequestReviewNext}
                  sx={{
                    mb: 1,
                    fontWeight: "bold",
                  }}
                  endIcon={
                    <FuseSvgIcon>material-outline:navigate_next</FuseSvgIcon>
                  }
                >
                  Confirm & Next
                </Button>
              )}
              {handleSubmitForReview && (
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={
                    ["SPACE_PLANNING", "INDIVIDUAL_KITCHEN_DESIGN"].includes(
                      status,
                    ) && !btnDisable
                      ? handleSubmitForReview
                      : () => {}
                  }
                  disabled={
                    !["SPACE_PLANNING", "INDIVIDUAL_KITCHEN_DESIGN"].includes(
                      status,
                    ) || btnDisable
                  }
                  sx={{
                    mb: 1,
                    fontWeight: "bold",
                  }}
                >
                  Submit for Review
                </Button>
              )}
              {handleRequestChange && (
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={
                    [
                      "SPACE_PLANNING_REVIEW",
                      "INDIVIDUAL_KITCHEN_DESIGN_REVIEW",
                    ].includes(status)
                      ? handleRequestChange
                      : () => {}
                  }
                  disabled={
                    ![
                      "SPACE_PLANNING_REVIEW",
                      "INDIVIDUAL_KITCHEN_DESIGN_REVIEW",
                    ].includes(status)
                  }
                  sx={{
                    mb: 1,
                    fontWeight: "bold",
                  }}
                >
                  Request a change
                </Button>
              )}
              {handleApprove && (
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={
                    status === "SPACE_PLANNING_REVIEW"
                      ? handleApprove
                      : () => {}
                  }
                  disabled={status !== "SPACE_PLANNING_REVIEW" || btnDisable}
                  sx={{
                    mb: 1,
                    fontWeight: "bold",
                  }}
                >
                  Approve
                </Button>
              )}
              {handleApproveAll && (
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={
                    status === "INDIVIDUAL_KITCHEN_DESIGN_REVIEW"
                      ? handleApproveAll
                      : () => {}
                  }
                  disabled={
                    status !== "INDIVIDUAL_KITCHEN_DESIGN_REVIEW" || btnDisable
                  }
                  sx={{
                    mb: 1,
                    fontWeight: "bold",
                  }}
                >
                  APPROVE ALL & Place Order
                </Button>
              )}
              {gridRef && (
                <Tooltip title={"Default Grid State"}>
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleDefaultGridState}
                    style={{ fontWeight: "bold", height: "36px" }}
                  >
                    <FuseSvgIcon>material-outline:grid_on</FuseSvgIcon>
                  </Button>
                </Tooltip>
              )}
            </Stack>
          </div>
        </div>
        {error === "Network Error" || error === "Service Unavailable" ? (
          <>
            <Dialog
              open={open}
              onClose={handleClose}
              fullWidth
              maxWidth="sm"
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogContent sx={{ height: "auto", alignItems: "center" }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <NetworkWifi3BarIcon
                    sx={{
                      height: { xs: 72, sm: 100 },
                      width: { xs: 72, sm: 100 },
                      color: theme.palette.warning.main,
                    }}
                  />
                </Box>
                <DialogContentText
                  id="alert-dialog-description"
                  align="center"
                  component="div"
                >
                  <Typography variant="h5">
                    Please try after some time. Server is under maintenance.
                  </Typography>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} autoFocus>
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          </>
        ) : (
          <>
            {error && (
              <Alert severity="error" className="mb-16">
                <AlertTitle>Error</AlertTitle>
                {error}
              </Alert>
            )}
          </>
        )}
      </AppBar>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={setSnackState ? snackState : openSnack}
        autoHideDuration={6000}
        disableWindowBlurListener={true}
        onClose={handleSnackClose}
        sx={{ top: "60px !important" }}
      >
        <Alert
          onClose={handleSnackClose}
          severity="success"
          variant="filled"
          sx={{
            width: "100%",
            bgcolor: theme.palette.secondary.main,
            color: theme.palette.secondary.contrastText,
          }}
        >
          {successMsg}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ListPageHeader;
